import Vue from 'vue';
import { DatePicker } from 'element-ui';

// Vue.component(DatePicker.name, DatePicker);
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 };
Vue.use(DatePicker);



// WEBPACK FOOTER //
// ./src/elementUi.js